import { sucursalesGet } from "#api/Api"
import { perfilesPuestoGet } from "#api/Api/perfilPuesto"
import { colaboradoresAllGet, colaboradoresTeamGet } from "#api/colaboradores"
import { InputAutocomplete } from "#common/input/InputAutocomplete"
import InputNumber from "#common/input/InputNumber"
import CircularSkeleton from "#common/skeleton/CircularSkeleton"
import { PERFILES } from "#constants/Strings"
import { DialogMaster } from "#core/components/dialog/Dialog"
import { useApi } from "#hooks/useApi"
import { UseHasPermission } from "#hooks/useHasPermission"
import { vacancyGet } from "#vacancy/services/api"
import OpenInNewIcon from "@mui/icons-material/OpenInNew"
import { Box, Button, Divider, Tooltip, Typography } from "@mui/material"
import Grid2 from "@mui/material/Unstable_Grid2"
import { useEffect, useMemo, useState } from "react"
import { generatePath } from "react-router-dom"
import { toast } from "react-toastify"

export function VacancyForm({ vacante, setVacante, promotion, list }) {
	const { sucursales, colaboradores, perfiles, tipos, duration, loading } =
		UseVacanteFormulario(promotion, list)
	const [confirm, setConfirm] = useState(false)

	const { data: info, loading: loadingInfo, fetch } = useApi(vacancyGet)
	console.log("info", info)

	useEffect(() => {
		if (vacante?.perfil_puesto && vacante?.sucursal && !promotion)
			fetch({
				check_vacante: true,
				perfil_puesto: vacante.perfil_puesto,
				sucursal: vacante.sucursal,
			})
	}, [fetch, promotion, vacante.perfil_puesto, vacante.sucursal])

	useEffect(() => {
		if (info?.promotion_exists && loadingInfo === false)
			setConfirm(info?.promotion_exists)
	}, [info?.promotion_exists, loadingInfo])

	const isPromotion = !["Promoción"].includes(vacante?.tipo_vacante)
	const inputs = useMemo(() => {
		const inputs = [
			{
				label: "General",
				grid: { xs: 12 },
				type: "Separador",
			},
			{
				label: "Perfil Puesto *",
				value: "perfil_puesto",
				grid: { xs: 11, md: 5 },
				options: perfiles,
				valueLabel: "nombre",
				type: "Autocomplete",
				disabled: promotion,
			},
			{
				value: "perfil_puesto",
				grid: { xs: 2 },
				type: "link",
			},
			{
				label: "Sucursal *",
				value: "sucursal",
				grid: { xs: 12, md: 5 },
				options: sucursales,
				valueLabel: "nombre",
				type: "Autocomplete",
				disabled: promotion,
			},
			{
				label: "Jefe Directo *",
				value: "jefe_directo",
				grid: { xs: 12, md: 5 },
				options: colaboradores,
				valueLabel: "full_name",
				type: "Autocomplete",
				disabled: promotion,
			},
			{
				label: "Tipo de Vacante *",
				value: "tipo_vacante",
				grid: { xs: 12, md: 5 },
				options: tipos,
				type: "Autocomplete",
				disabled: promotion,
			},
			{
				label: "¿Por Quien? *",
				value: "colaborador",
				grid: { xs: 12, md: !isPromotion ? 10 : 12 },
				options: colaboradores,
				valueLabel: "full_name",
				type: "Autocomplete",
				disabled: promotion,
				notShow: !["Reemplazo", "Promoción"].includes(vacante?.tipo_vacante),
			},
			{
				label: "Promoción *",
				value: "promotion",
				grid: { xs: 12, md: 2 },
				type: "Number",
				notShow: isPromotion,
				disabled: promotion,
			},
			{
				label: "Sueldo",
				grid: { xs: 12 },
				type: "Separador",
			},
			{
				label: "Sueldo Mensual *",
				value: "sueldo_mensual",
				grid: { xs: 12, md: 5 },
				type: "Number",
			},
			{
				label: "Bono Trimestral *",
				value: "bono_trimestral",
				grid: { xs: 12, md: 5 },
				type: "Number",
			},
			{
				label: "Garantía *",
				value: "garantia",
				grid: { xs: 12, md: 5 },
				type: "Number",
			},

			{
				label: "Duración de la Garantía",
				value: "duracion",
				grid: { xs: 12, md: 5 },
				options: duration,
				valueLabel: "id",
				type: "Autocomplete",
			},
		]

		return inputs.map((input) => {
			let component = null

			if (input.notShow) return null
			switch (input.type) {
				case "Autocomplete":
					component = (
						<InputAutocomplete
							disabled={input?.disabled}
							key={input.value}
							label={input.label}
							options={input?.options || []}
							valueLabel={input.valueLabel}
							value={vacante[input.value]}
							setValue={(value) =>
								setVacante((data) => ({ ...data, [input.value]: value }))
							}
							valueId="id"
						/>
					)
					break
				case "Number":
					component = (
						<InputNumber
							key={input.value}
							size="medium"
							fullWidth
							label={input.label}
							value={vacante[input.value]}
							setValue={(value) =>
								setVacante((data) => ({ ...data, [input.value]: value }))
							}
							disabled={input?.disabled}
						/>
					)
					break
				case "Separador":
					component = (
						<Divider textAlign="left">
							<Typography variant="h5" key={input.label}>
								{input.label}
							</Typography>
						</Divider>
					)
					break
				case "link":
					component = (
						<Box
							display="flex"
							justifyContent="left"
							alignItems="stretch" // 👈 hace que los hijos crezcan a la misma altura
							height="100%" // 👈 usa todo el alto disponible del contenedor padre
						>
							<Tooltip title="Ver Perfil Puesto">
								<Button
									variant="text"
									fullWidth
									sx={{ height: "100%", width: "30%" }} // 👈 el botón ocupa todo el alto del Box
									onClick={() => {
										const path = generatePath("/perfil-puesto/" + vacante[input.value])
										window.open(path, "_blank")
									}}
									disabled={vacante[input.value] === undefined}
								>
									<OpenInNewIcon />
								</Button>
							</Tooltip>
						</Box>
					)
					break
				default:
					component = null
			}

			return (
				<Grid2 key={input.value} {...input.grid}>
					{component}
				</Grid2>
			)
		})
	}, [
		colaboradores,
		duration,
		isPromotion,
		perfiles,
		promotion,
		setVacante,
		sucursales,
		tipos,
		vacante,
	])

	if (loading) return <CircularSkeleton />

	return (
		<Box>
			<Grid2
				container
				spacing={1}
				justifyContent="space-between" // 👈 distribuye los ítems a los extremos
			>
				{inputs}
			</Grid2>
			<ConfirmPromotion open={confirm} setOpen={setConfirm} />
		</Box>
	)
}

export const VacancyFormValidation = (vacante) => {
	const check = [
		{
			id: "tipo_vacante",
			label: "Tipo Vacante",
		},
		{
			id: "sueldo_mensual",
			label: "Sueldo Mensual",
		},
		{
			id: "bono_trimestral",
			label: "Bono Trimestral",
		},
		{
			id: "garantia",
			label: "Garantía",
		},
		{
			id: "duracion",
			label: "Duración de la Garantía",
		},
	]
	console.log(vacante)

	for (const index in check) {
		const field = check[index]
		const value = vacante[field.id]
		if (value === undefined || value === null || value === "" || value < 0) {
			toast.error(`se necesita el campo ${field.label}.`)
			return false
		}
	}
	if (vacante.sueldo_mensual <= 0) {
		toast.error("El Sueldo Mensual debe ser mayor a 0.")
		return false
	}

	return true
}

const UseVacanteFormulario = (promotion, list) => {
	const [colaboradores, setColaboradores] = useState([])
	const [perfiles, setPerfiles] = useState([])
	const [sucursales, setSucursales] = useState([])
	const [loading, setLoading] = useState(true)
	const isRh = UseHasPermission(PERFILES.RH)
	const tipos = useMemo(() => {
		let tipos = [
			{ id: "Nueva Creación", label: "Nueva Creación" },
			{ id: "Reemplazo", label: "Reemplazo" },
			{ id: "Becario", label: "Becario" },
		]
		if (promotion || isRh) tipos.push({ id: "Promoción", label: "Promoción" })
		return tipos
	}, [isRh, promotion])

	const duration = useMemo(
		() => [
			{ id: "N/A", label: "N/A" },
			{ id: "Indefinido", label: "Indefinido" },
			{ id: "3 meses", label: "3 meses" },
			{ id: "6 meses", label: "6 meses" },
		],
		[]
	)

	const list_control = useMemo(() => {
		return list
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [JSON.stringify(list)])

	useEffect(() => {
		// if (!promotion) {
		let all = []
		all.push(
			perfilesPuestoGet({
				all: true,
				success: (data) => {
					setPerfiles(data.data)
				},
			})
		)
		if (isRh)
			all.push(
				colaboradoresAllGet({
					success: (data) => setColaboradores(data),
					params: { list: true },
				})
			)
		else
			all.push(
				colaboradoresTeamGet(0, {
					success: (data) => setColaboradores(data),
					params: {
						list: true,
						sub_colaboradores: true,
						boss: true,
						all: true,
					},
				})
			)

		all.push(
			sucursalesGet({
				success: (data) => setSucursales(data.data),
			})
		)
		Promise.all(all).then(() => setLoading(false))
		// } else {
		// 	setSucursales(list_control.sucursales)
		// 	setPerfiles(list_control.perfiles)
		// 	setColaboradores(list_control.colaboradores)
		// 	setLoading(false)
		// }
	}, [isRh, list_control, promotion])

	return {
		sucursales,
		colaboradores,
		perfiles,
		tipos,
		duration,
		loading,
	}
}

const ConfirmPromotion = ({ open, setOpen }) => {
	const handlerSubmit = () => {
		setOpen(false)
	}
	return (
		<DialogMaster
			{...{
				open: open,
				setOpen,
				title: "Promoción en Proceso",
				maxWidth: "sm",
			}}
		>
			<Box>
				¿hay un procesos de promoción con esta vacante seguro de abrir la vacante ?
			</Box>
		</DialogMaster>
	)
}
